import type { ReactElement } from 'react';
import { Link } from 'react-router';

import { useBackState } from '@/lib/back-nav';
import { stageKindLabel } from '@/lib/stage-kind';
import { CardFrame, QueryBody } from '@/components/ui/card-frame';

import { formatDuration } from '../presentation';
import type { MyStage } from '../types';
import { useMyStages } from '../use-time-study';

// Mis etapas en curso (so=420, spec §4.2 tarjeta 2 y D6): documento, etapa, tiempo total
// y mi esfuerzo, con enlace al Editor donde corre el cronómetro.

function stageText(s: MyStage): string {
  return [
    stageKindLabel(s.stageKind),
    s.attempt > 1 ? `intento ${s.attempt}` : null,
    s.isReproceso ? 'reproceso' : null,
  ]
    .filter((x) => x !== null)
    .join(' · ');
}

export function MyStagesCard({ companyId }: { companyId: string }): ReactElement {
  const query = useMyStages({ companyId, enabled: true });
  const fromHere = useBackState('Estudio de tiempos');
  return (
    <CardFrame
      title="Mis etapas en curso"
      count={
        query.data
          ? `${query.data.length} ${query.data.length === 1 ? 'abierta' : 'abiertas'}`
          : undefined
      }
    >
      <QueryBody
        query={query}
        isEmpty={(d) => d.length === 0}
        emptyText="No tienes etapas en curso."
      >
        {(d) => (
          <ul className="rlist">
            {d.map((s) => (
              <li key={`${s.entryId}:${s.stageKind}`} className="rowb">
                <div className="grow">
                  <span className="code">{s.code}</span>
                  {s.title && <div className="sub">{s.title}</div>}
                  <div className="rl">{stageText(s)}</div>
                </div>
                <div className="myst">
                  <span className="dim-mono">
                    Total {formatDuration(s.macroSeconds)} · mío{' '}
                    {formatDuration(s.mine.effortSeconds)}
                  </span>
                  <Link
                    className="btn mut sm"
                    to={`/documentos/${s.entryId}/editor`}
                    state={fromHere}
                    aria-label={`Abrir ${s.code} en el editor`}
                  >
                    Abrir
                  </Link>
                </div>
              </li>
            ))}
          </ul>
        )}
      </QueryBody>
    </CardFrame>
  );
}
